import type { AnyAction, Reducer } from 'redux';
import { FinancingActions } from './financingActionTypes';
import type { FinancingState, SetFinancingInitialTabAction } from './types';

const initialState: FinancingState = {
    initialTab: 'buyer'
};

export const financingReducer: Reducer<FinancingState> = (
    state = initialState,
    action: SetFinancingInitialTabAction | AnyAction
) => {
    switch (action.type) {
        case FinancingActions.SET_FINANCING_INITIAL_TAB: {
            return {
                ...state,
                initialTab: action.payload
            };
        }
        default: {
            return state;
        }
    }
};
